/*
 * @Author: zfd
 * @Date: 2020-09-06 10:08:57
 * @LastEditTime: 2020-09-06 15:40:33
 * @Description: 
 * @FilePath: \trip-enterprise\src\api\user.js
 */
import axios from './index'
const origin = '/co/member/',
    menu = '/co/sys/';

const getCode=(param)=>{
    return new Promise((resolve, reject) => {
        axios.post(origin + 'ForgetPassWordGetCode', param).then(res => resolve(res)).catch(err => reject(err));
    })
}

const submitReset=(param)=>{
    return new Promise((resolve, reject) => {
        axios.post(origin + 'SubmitReset', param).then(res => resolve(res)).catch(err => reject(err));
    })
}

const login = (param) => {
    return new Promise((resolve, reject) => {
        axios.post(origin + 'login', param).then(res => resolve(res)).catch(err => reject(err));
    })
}
const getLoginerInfo = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + 'GetLoginerInfoParty', param).then(res => resolve(res))
    })
}
const getRouter = () => {
    return new Promise(resolve => {
        axios.get(menu + 'GetRouterTree').then(res => resolve(res));
    })
}
const changePassword = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + 'changePassword', param).then(res => resolve(res))
    })
}
const updateCompany = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + 'updateCompany', param).then(res => resolve(res))
    })
}
const getCompany = (id) => {
    return new Promise((resolve) => {
        axios.post(origin + 'GetCompany', id).then(res => resolve(res))
    })
}
export default {
    submitReset,
    getCode,
    login,
    getLoginerInfo,
    getRouter,
    changePassword,
    updateCompany,
    getCompany
}